import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2, X } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export const FlirtCoach = ({ matchId, onPick }) => {
  const [ideas, setIdeas] = useState([]);
  const [loading, setLoading] = useState(false);
  const ask = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/messages/${matchId}/suggest`);
      setIdeas(data.suggestions || []);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Coach is busy, try again"); } finally { setLoading(false); }
  };
  const pick = (t) => { onPick(t); setIdeas([]); };
  return (
    <div className="px-4 pt-3" data-testid="flirt-coach">
      {ideas.length > 0 ? (
        <div className="space-y-2">
          <div className="flex items-center justify-between text-xs text-[#A0A0A0]">
            <span className="flex items-center gap-1.5"><Sparkles size={12} className="text-[#D4AF37]" /> Tap one to edit, then send</span>
            <button type="button" data-testid="coach-close" onClick={() => setIdeas([])} className="hover:text-white"><X size={14} /></button>
          </div>
          {ideas.map((t, i) => (
            <button type="button" key={i} data-testid={`coach-suggestion-${i}`} onClick={() => pick(t)}
              className="block w-full text-left text-sm px-4 py-2.5 rounded-2xl border border-[#D4AF37]/30 bg-[#D4AF37]/5 text-white hover:bg-[#D4AF37]/15 hover:border-[#D4AF37]/60 transition-colors">
              {t}
            </button>
          ))}
          <button type="button" data-testid="coach-more" onClick={ask} disabled={loading} className="text-xs text-[#D4AF37] hover:underline disabled:opacity-50">
            {loading ? "Thinking…" : "Show me 3 more"}
          </button>
        </div>
      ) : (
        <button type="button" data-testid="coach-help-btn" onClick={ask} disabled={loading}
          className="text-xs px-3 py-1.5 rounded-full border border-[#D4AF37]/50 text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-colors flex items-center gap-1.5 disabled:opacity-60">
          {loading ? <Loader2 size={12} className="animate-spin" /> : <Sparkles size={12} />} {loading ? "Thinking of something charming…" : "Help me reply"}
        </button>
      )}
    </div>
  );
};
